// Belge Kontrol (/belge-kontrol) ve ziyaret inceleme ekranı. Bulgular, ziyaret
// özeti ve belge notları sunucudan Türkçe gelir; hemşireye yapıştırılan düzeltme
// listesi de Türkçe kalır.
const belgeKontrol = {
  page: {
    title: 'Belge Kontrol',
    subtitle: 'Ziyaret belgelerini yükleyin; yapay zeka okur, kontroller hataları işaretler, siz onaylarsınız.',
    newVisit: 'Yeni ziyaret',
  },
  tabs: {
    label: 'Belge Kontrol bölümleri',
    visits: 'Ziyaretler',
    participants: 'Katılımcı belgeleri',
  },
  access: {
    checking: 'Yetki kontrol ediliyor…',
    denied: 'Erişim yetkiniz yok.',
  },
  errors: { load: 'Veriler yüklenemedi.' },
  common: { loading: 'Yükleniyor…' },
  kinds: {
    SCHEDULED: 'Planlı ziyaret (Hafta)',
    UNSCHEDULED: 'Plansız ziyaret (UNS)',
    OTHER: 'Diğer',
  },
  kindsShort: {
    SCHEDULED: 'Planlı (Hafta)',
    UNSCHEDULED: 'Plansız (UNS)',
    OTHER: 'Diğer',
  },
  visitStatus: {
    draft: 'Belge bekleniyor',
    processing: 'Okunuyor',
    checked: 'İncelemede',
    completed: 'Kontrol tamamlandı',
  },
  visitStatusShort: {
    draft: 'Belge yok',
    processing: 'Okunuyor',
    checked: 'İncelemede',
    completed: 'Tamam',
  },
  docStatus: {
    queued: 'Sırada',
    reading: 'Okunuyor…',
    read: 'Okundu',
    unreadable: 'Okunamadı',
    error: 'Hata',
  },
  severity: {
    critical: 'Kritik',
    warning: 'Uyarı',
    info: 'Bilgi',
  },
  owners: {
    CMRN: 'Hemşire',
    SITE: 'Eczacı / Site',
    REVIEWER: 'Siz',
  },
  docTypes: {
    HOME_INFUSION_SDW: 'SDW – Evde İnfüzyon',
    SAMPLE_COLLECTION_SDW: 'SDW – Numune Toplama',
    UNSCHEDULED_SDW: 'SDW – Plansız Ziyaret',
    HOME_ASSESSMENT_SDW: 'SDW – Ev Değerlendirmesi',
    CHAIN_OF_CUSTODY: 'Gözetim Zinciri',
    QUICKSTAT: 'QuickSTAT irsaliyesi',
    LRF: 'LRF (Labcorp)',
    TCCF: 'TCCF',
    CAW: 'Çalışma formu (CAW)',
    DCF: 'DCF',
    POF: 'POF',
    POF_UNS: 'POF-UNS',
    IRR_ORDER: 'IRR order formu',
    PRF: 'PRF',
    PROFORMA_INVOICE: 'Proforma fatura',
    MEET_GREET: 'Tanışma görüşmesi',
    SITE_CONTACT_INFO: 'Site iletişim formu',
    TCCA_CMRN: 'TCCA (CMRN eğitimi)',
    UNKNOWN: 'Tanınmayan belge',
  },
  counts: {
    critical: '{{count}} kritik',
    warning: '{{count}} uyarı',
    clean: 'Sorun yok',
    open: '{{count}} bekliyor',
  },
  columns: {
    participantId: 'Katılımcı',
    actions: 'İşlem',
    label: 'Ziyaret',
    visitDate: 'Tarih',
    status: 'Durum',
    findings: 'Bulgular',
    nurse: 'Hemşire',
    createdBy: 'Oluşturan',
    kind: 'Ziyaret türü',
    hasSamples: 'Numune',
    createdAt: 'Oluşturulma',
    costUsd: 'API maliyeti',
  },
  table: {
    listLabel: 'Ziyaretler',
    open: 'İncele',
    openHint: 'Ziyaretin inceleme ekranını aç',
    empty: 'Filtrelere uyan ziyaret yok',
    noVisits: 'Henüz ziyaret yok. “Yeni ziyaret” ile başlayın.',
    rangeOf: '/ {{total}} ziyaret',
    ofTotal: 'toplam {{total}} ziyaretten',
  },
  stats: {
    total: 'Toplam Ziyaret',
    totalShort: 'Toplam',
    checked: 'İncelemede',
    checkedShort: 'İncelemede',
    critical: 'Kritik Bulgulu',
    criticalShort: 'Kritik',
    completed: 'Kontrol Tamamlandı',
    completedShort: 'Tamamlandı',
    share: 'Tüm ziyaretlerin %{{percent}}’i',
  },
  status: { all: 'Tümü' },
  toolbar: {
    search: 'Katılımcı no, ziyaret, hemşire ara…',
    searchShort: 'Ziyaret ara…',
    status: 'Ziyaret durumu',
    pending: 'Karar bekleyen',
    pendingHint: 'Yalnızca kararı verilmemiş bulgusu olan ziyaretler',
    critical: 'Kritik bulgulu',
    criticalHint: 'Yalnızca kritik bulgusu olan ziyaretler',
  },
  sort: {
    label: 'Sırala',
    asc: 'Artan sıra',
    desc: 'Azalan sıra',
    createdAt: 'Oluşturulma',
    visitDate: 'Ziyaret tarihi',
    participantId: 'Katılımcı',
  },
  panel: {
    label: 'Seçili ziyaret',
    heading: 'Ziyaret',
    open: 'İncelemeyi aç',
    delete: 'Ziyareti sil',
    findings: 'Bulgular',
    noChecks: 'Kontroller henüz çalışmadı.',
    note: 'Not',
    counts: {
      critical: 'Kritik',
      warning: 'Uyarı',
      open: 'Bekliyor',
    },
    samplesYes: 'Numune alındı',
    samplesNo: 'Numune yok',
    completedBy: 'Kontrolü tamamlayan',
  },
  confirm: {
    cancel: 'Vazgeç',
    deleteVisit: {
      title: 'Ziyaret silinsin mi?',
      message: 'Bu ziyaret, tüm belgeleri ve bulgularıyla birlikte silinsin mi?',
      confirm: 'Ziyareti sil',
    },
    deleteDocument: {
      title: 'Belge silinsin mi?',
      message: '"{{name}}" silinsin mi?',
      confirm: 'Belgeyi sil',
    },
  },
  toast: {
    visitCreated: 'Ziyaret oluşturuldu. Şimdi belgeleri yükleyin.',
    visitDeleted: 'Ziyaret silindi.',
    demoCreated: 'Test ziyareti oluşturuldu.',
    documentDeleted: 'Belge silindi.',
    openFailed: 'Dosya açılamadı.',
    tooLarge: '{{name}} çok büyük (en fazla 45 MB).',
    unsupported: 'Desteklenmeyen dosya: {{names}}',
    lowResolution: 'Bazı fotoğrafların çözünürlüğü düşük; okunamayabilir. Mümkünse daha yakından/yüksek çözünürlükte çekin.',
    copied: 'Düzeltme listesi panoya kopyalandı.',
    copyFailed: 'Kopyalanamadı.',
    rerunDone: 'Kontroller yeniden çalıştırıldı.',
    completed: 'Kontrol tamamlandı.',
  },
  newVisit: {
    title: 'Yeni ziyaret kontrolü',
    subtitle: 'Ziyareti oluşturun, sonra belgelerini yükleyin.',
    participant: 'Katılımcı no',
    participantError: 'Katılımcı no 4 rakam - 4 rakam olmalı (ör. 1556-0002).',
    kind: 'Ziyaret türü',
    week: 'Hafta',
    unsNumber: 'Plansız ziyaret no',
    date: 'Ziyaret tarihi',
    samples: 'Bu ziyarette numune alındı',
    samplesHint: 'Numune Toplama SDW, LRF ve TCCF beklenir.',
    note: 'Not (isteğe bağlı)',
    missing: {
      participant: 'katılımcı no (1556-0002 biçiminde)',
      week: 'hafta',
      date: 'ziyaret tarihi',
    },
    missingPrefix: 'Oluşturmak için eksik: {{list}}.',
    cancel: 'Vazgeç',
    create: 'Oluştur',
    creating: 'Oluşturuluyor…',
  },
  demo: {
    button: 'Test simülasyonu',
    title: 'Test simülasyonu (geçici)',
    intro: 'Gerçek belgelerde bulunan hatalarla hazırlanmış örnek okumalar kullanılır. Yapay zeka çağrılmaz, ücret oluşmaz; kontroller gerçek sistemdekiyle aynıdır. Oluşan ziyarette bulguları onaylayıp reddedebilir, sonra silebilirsiniz.',
  },
  upload: {
    title: 'Dosyaları sürükleyin veya seçmek için tıklayın',
    hint: 'Her PDF ayrı bir belge olarak okunur. Aynı belgenin fotoğraflarını birlikte seçerseniz tek PDF’te birleştirilir.',
    formats: 'PDF, JPG, PNG, WEBP · en fazla 45 MB',
  },
  documents: {
    title: 'Belgeler ({{count}})',
    add: 'Belge ekle',
    closeUpload: 'Kapat',
    detecting: 'Belge türü belirleniyor…',
    pages: '{{count}} sayfa',
    simulation: 'Simülasyon',
    unreadable: 'Bu dosya okunamadı, lütfen daha iyi çözünürlükte yükleyin.',
    unreadablePages: '(Okunamayan sayfalar: {{pages}})',
    poorPages: 'Sayfa {{pages}} net okunamadı. Sonuçları elle kontrol edin veya daha iyi çözünürlükte yükleyin.',
    poorPagesShort: 'Sayfa {{pages}} net değil',
    failed: 'İşlenemedi: {{error}}',
    unknownError: 'bilinmeyen hata',
    open: 'Aç',
    openTitle: 'Belgeyi aç',
    reread: 'Tekrar oku',
    delete: 'Sil',
    none: 'Henüz belge yüklenmedi.',
    filterHint: '{{name}} – bulgularını göstermek için tıklayın',
    openFindings: 'İncelenecek bulgu',
    missing: 'Eksik – yüklenmemiş',
    missingHint: 'Bu ziyaret türü için gerekli',
  },
  participants: {
    listLabel: 'Katılımcılar',
    search: 'Katılımcı no ara veya ekle',
    open: 'Aç / ekle',
    openHint: 'Tam katılımcı numarasıyla açar; yoksa ekler',
    count: '{{count}} katılımcı',
    empty: 'Henüz katılımcı yok.',
    hasReference: 'Referans var',
    noReference: 'Referans yok',
    selectHint: 'Referans belgelerini görmek için bir katılımcı seçin.',
    back: 'Katılımcılar',
    reference: 'Referans bilgileri',
    referenceEmpty: 'Referans bilgisi yok. PRF, POF ve IRR order formlarını yükleyin.',
    dob: 'Doğum tarihi',
    bpArm: 'Tansiyon kolu',
    pofValidity: 'POF geçerlilik',
    weeks: '{{from}}.–{{to}}. hafta',
    route: 'Uygulama yolu',
    dose: 'Doz',
    irr: 'IRR order',
    irrValue: '{{date}} imzalı, {{from}}.–{{to}}. hafta',
    documents: 'Referans belgeleri',
    uploadHint: 'PRF (Gönüllü Kayıt Formu), POF ve IRR Order Formu. Yeni POF/IRR geldikçe yükleyin; en son yüklenen kullanılır.',
    tiles: {
      total: 'Katılımcı',
      totalShort: 'Katılımcı',
      with: 'Referansı Olan',
      withShort: 'Referanslı',
      without: 'Referansı Olmayan',
      withoutShort: 'Referanssız',
    },
  },
  visit: {
    week: 'Hafta {{week}}',
    test: 'TEST',
    samples: 'Numuneli',
    nurse: 'Hemşire: {{name}}',
    cost: 'API maliyeti ≈ {{cost}}',
    back: 'Ziyaretler',
    more: 'Diğer işlemler',
    rerun: 'Kontrolleri yeniden çalıştır',
    delete: 'Ziyareti sil',
    notFound: 'Ziyaret bulunamadı.',
    uploadTitle: 'Ziyaret belgelerini yükleyin',
    uploadText: 'Ziyaretin tüm belgelerini (SDW, Gözetim Zinciri, QuickSTAT, LRF…) tek seferde yükleyebilirsiniz. Belge türleri otomatik tanınır; okuma bitince kontroller kendiliğinden çalışır ve bulgular burada listelenir.',
    readingTitle: 'Belgeler okunuyor…',
    readingText: 'Tüm belgeler okununca kontroller çalışacak ve bulgular burada listelenecek.',
    demoNotice: 'Test simülasyonu: belgeler gerçek tarama değil; gerçek belgelerdeki hatalarla hazırlanmış örnek okumalardır. Kontroller gerçek sistemle aynıdır.',
    note: 'Not: {{note}}',
    ruleErrors: 'Bazı kontroller çalışamadı: {{errors}}',
    panes: 'Ziyaret bölümleri',
    paneSummary: 'Hemşire',
    paneDocuments: 'Belgeler',
  },
  verdict: {
    noDocuments: { title: 'Belge bekleniyor', text: 'Ziyaretin belgelerini yükleyin; okuma bitince kontroller kendiliğinden çalışır.' },
    reading: { title: 'Belgeler okunuyor…', text: '{{read}} / {{total}} belge okundu. Bitince kontroller kendiliğinden çalışır.' },
    completed: { title: 'Kontrol tamamlandı', text: '{{name}} · {{date}} · {{count}} düzeltme istendi' },
    clean: { title: 'Sorun bulunmadı', text: 'Kontroller bu ziyarette düzeltilecek bir şey bulmadı. Kontrolü tamamlayabilirsiniz.' },
    reviewedFixes: { title: 'İnceleme bitti', text: '{{count}} düzeltme gerekiyor. Listeyi kopyalayıp ilgili kişilere gönderin, sonra kontrolü tamamlayın.' },
    reviewedClean: { title: 'İnceleme bitti', text: 'Tüm bulgular "sorun yok" olarak işaretlendi.' },
    needsFix: { title: 'Düzeltme gerekiyor', text: '{{found}} bulundu. Her bulguyu inceleyip karar verin.' },
    needsCheck: { title: 'Kontrol edilmesi gereken noktalar var', text: '{{found}} bulundu.' },
  },
  review: {
    ownerHint: 'Bu kişinin bulgularını göster',
    progress: 'İncelenen bulgu',
    complete: 'Kontrolü tamamla',
    completeHint: 'Önce tüm bulgular incelenmeli',
    copy: 'Düzeltme listesini kopyala',
    copyHint: '"Düzeltilmeli" işaretlenen bulgu yok',
  },
  findings: {
    title: 'Bulgular',
    viewLabel: 'Bulgu görünümü',
    views: {
      todo: 'İncelenecek',
      done: 'Karar verilen',
      all: 'Tümü',
    },
    filterOwner: 'Kim: {{name}}',
    filterDoc: 'Belge: {{name}}',
    clearFilter: 'Filtreyi kaldır',
    cleanTitle: 'Sorun bulunmadı',
    cleanText: 'Kontroller bu ziyarette düzeltilecek bir şey bulmadı.',
    doneTitle: 'Tüm bulgular incelendi',
    doneText: 'Üstteki “Kontrolü tamamla” ile ziyareti kapatabilirsiniz.',
    closedText: 'Bu ziyaretin kontrolü tamamlandı.',
    emptyFilter: 'Bu filtrede incelenecek bulgu yok.',
    emptyView: 'Bu görünümde bulgu yok.',
    visitWide: 'Ziyaret geneli',
    infoNotes: 'Bilgi notları ({{count}}) – karar gerektirmez',
  },
  finding: {
    observed: 'Belgede',
    message: 'Tespit',
    action: 'Yapılacak',
    page: 'Sayfa {{page}}',
    openPage: 'Sayfayı aç',
    openDocument: 'Belgeyi aç',
    fix: '✓ Düzeltilmeli',
    ok: '✓ Sorun yok',
    details: 'Detay',
    hide: 'Gizle',
    undo: 'Geri al',
    decideFix: 'Düzeltilmeli',
    decideOk: 'Sorun yok',
    addNote: 'Not ekle',
    notePlaceholder: 'Not (isteğe bağlı) – karar verirken kaydedilir',
  },
  summary: {
    title: 'Hemşirenin yaptıkları',
    reading: 'Belgeler okunuyor; bitince ziyaretin özeti burada görünecek.',
    empty: 'Özet için “Kontrolleri yeniden çalıştır”ı kullanın veya belgeleri yükleyin.',
    age: 'Katılımcı {{age}} yaşında',
    vitals: 'Vital bulgular',
    flaggedHint: 'Bu adımla ilgili bulgu var',
    measure: 'Ölçüm',
    outOfRange: 'Referans dışı',
  },
};

export default belgeKontrol;
